import {
  type FieldValues,
  type FormItemWrapperProps,
  type Path,
  type PathValue,
  type UseControllerProps,
  useCustomController,
} from '@faceup/form'
import { FileFormElement } from '@faceup/report'
import { FormItem } from '@faceup/ui'
import { FORM_ITEMS, FormItemType } from '@faceup/utils'

type SurveyFileUploadProps<T extends FieldValues> = UseControllerProps<T> &
  FormItemWrapperProps & {
    fieldId: string
  }

export const SurveyFileUpload = <T extends FieldValues>(props: SurveyFileUploadProps<T>) => {
  const {
    formItemProps,
    inputProps: { onChange },
  } = useCustomController({
    ...props,
    defaultValue: undefined as PathValue<T, Path<T>>,
  })

  const { fieldId } = props

  const setFile = (file: File | null) => {
    onChange(file)
  }

  return (
    <FormItem {...formItemProps} notClickableLabel>
      <FileFormElement
        key={fieldId}
        name={fieldId}
        multiple={false}
        maxCount={FORM_ITEMS[FormItemType.File].maxSurveyCount}
        className='w-full'
        onRemove={() => {
          setFile(null)
          return true
        }}
        onChange={({ file }) => {
          if (file.originFileObj instanceof File) {
            setFile(file.originFileObj)
          }
        }}
      />
    </FormItem>
  )
}
